<template>
  <div class="GroupNameUpdate">
    <van-nav-bar
      title="修改群聊名称"
      fixed
      right-text="修改"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-cell-group>
      <div class="text">群名称</div>
      <van-field v-model="groupName" border clearable />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "GroupNameUpdate",
  data() {
    return {
      ug_id: "",
      groupName: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  methods: {
    loadData() {
      var params = {
        ug_id: this.ug_id,
        token: this.token,
        u_id: this.u_id
      };
      var url = this.Conf.serverUrl + "Groups/getGroupInfoById" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            this.groupName = response.data.result.ug_name;
          }
          // console.log(this.groupName);
        })
        .catch(error => {});
    },
    // 返回
    onClickLeft() {
      this.$router.push({
        name: "GroupChatSet",
        query: {
          ug_id: this.ug_id
        }
      });
    },
    // 修改按钮
    onClickRight() {
      var params = {
        ug_id: this.ug_id,
        groupName: this.groupName,
        token: this.token,
        u_id: this.u_id
      };
      var url = this.Conf.serverUrl + "Groups/groupNameUpdate" + "?num="+Math.random();
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch (response.data.code) {
            case 200:
              this.$toast.success(response.data.msg);
               this.onClickLeft();
              break;
            case 40001:
              this.$toast.fail(response.data.msg);
              break;
          }
        })
        .catch(error => {});
    }
  },
  created() {
    var params = this.$route.query;
    this.ug_id = params.ug_id;
    this.loadData();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Group/GroupNameUpdate.vue